import { FC } from "react";
import LoginForm from "./LoginForm";
import PageTemplate from "../PageTemplate";

const Login: FC = () => {
    return <PageTemplate Page={LoginForm} />;
};

export default Login;
